module.exports = __webpack_public_path__ + "img/saastopankki-logo.9c153edd.svg";